import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./MultiSelectFilterForm.state";
import { MultiSelectFilterForm } from "./MultiSelectFilterForm";

MultiSelectFilterForm.reducer = reducer;
MultiSelectFilterForm.mapStateToProps = mapStateToProps;
MultiSelectFilterForm.mapDispatchToProps = mapDispatchToProps;

export default MultiSelectFilterForm;
